<template>
  <div>
    <div v-if="loading == false">
      <v-card
        outlined
        max-width="720px"
        style="margin: 30px auto"
        v-if="surveyValid == false || noSurveyFound == true"
        class="survey-wrapper"
      >
        <v-card-text>
          <a
            v-if="noSurveyFound == false"
            :href="compData.url"
            target="_blank"
            class="survey-logo-client"
          >
            <v-img :src="compData.logoUrl">
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </a>
          <div v-if="survey.clientLanguage == 'nl'">
            >
            <h2 class="text-center">Beoordeling verlopen</h2>
            <p class="text-center" style="padding-bottom: 50px;">
              Hartelijk dank voor uw deelname aan deze beoordeling. De maximale
              tijd om uw bezoek te beoordelen is helaas verlopen.
            </p>
          </div>
          <div v-else>
            <h2 class="text-center">Review expired</h2>
            <p class="text-center" style="padding-bottom: 50px;">
              Thank you for participating in this review. Unfortunately, the
              maximum time to review your visit has expired.
            </p>
          </div>
        </v-card-text>
      </v-card>

      <v-card
        max-width="720px"
        outlined
        style="margin: 30px auto"
        v-if="surveyValid == true && noSurveyFound == false"
      >
        <v-card-text>
          <a :href="compData.url" target="_blank" class="survey-logo-client">
            <v-img :src="compData.logoUrl">
              <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout>
            </v-img>
          </a>

          <div v-if="survey.clientLanguage == 'nl'">
            <h2 class="text-center pb-3">Hartelijk dank</h2>
            <p
              class="text-center"
              v-if="dataLeft > 0"
              v-html="compData.pageIntro[survey.clientLanguage]"
            ></p>
            <p class="text-center" v-if="!dataLeft">
              Hartelijk dank voor het volledig invullen van dit onderzoek.
            </p>
          </div>

          <div v-else>
            <h2 class="text-center pb-3">Thank you</h2>
            <p
              class="text-center"
              v-if="dataLeft > 0"
              v-html="compData.pageIntro[survey.clientLanguage]"
            ></p>
            <p class="text-center" v-if="!dataLeft">
              Thank you for completing this survey completely.
            </p>
          </div>

          <div
            v-if="
              surveyValid == true &&
                noSurveyFound == false &&
                ratingSumData.length > 0 &&
                dataLeft > 0
            "
            class="score-wrapper pb-4"
          >
            <p class="text-center" v-if="survey.clientLanguage == 'nl'">
              <b>Gemiddelde score</b>
            </p>
            <p class="text-center" v-else><b>Average score</b></p>
            <p class="text-center average-score">{{ averageScore }}</p>
          </div>

          <div class="extra-survey-wrapper" v-if="dataLeft > 0">
            <p
              class="extra-survey-intro-header text-center ma-0"
              v-if="survey.clientLanguage == 'nl'"
            >
              <span v-if="dataLeft == 1"
                >{{ dataLeft }} ander aspect beoordelen?</span
              >
              <span v-if="dataLeft > 1"
                >{{ dataLeft }} andere aspecten beoordelen?</span
              >
            </p>
            <p class="extra-survey-intro-header text-center" v-else>
              <span v-if="dataLeft == 1"
                >Evaluate {{ dataLeft }} other aspect?</span
              >
              <span v-if="dataLeft > 1"
                >Evaluate {{ dataLeft }} other aspects?</span
              >
            </p>
            <p
              class="text-center"
              v-html="compData.pageAspects[survey.clientLanguage]"
            ></p>

            <div
              class="survey-items-wrapper"
              v-for="question in surveyData"
              :key="question.order"
            >
              <div
                class="survey-item"
                :class="{ selected: question.rating }"
                v-if="!question.answered && question.type == 'rating'"
              >
                <h2 class="text-center">
                  {{ question.question[survey.clientLanguage] }}
                </h2>
                <div class="icon-wrapper clear">
                  <v-radio-group
                    v-model="question.rating"
                    :mandatory="false"
                    @click.native="ratingSum()"
                  >
                    <a
                      class="rating-icon rating-slecht"
                      :class="'rating-' + question.rating"
                      ><v-radio label="slecht" value="1"></v-radio
                    ></a>
                    <a
                      class="rating-icon rating-onvoldoende"
                      :class="'rating-' + question.rating"
                      ><v-radio label="onvoldoende" value="2"></v-radio
                    ></a>
                    <a
                      class="rating-icon rating-voldoende"
                      :class="'rating-' + question.rating"
                      ><v-radio label="voldoende" value="3"></v-radio
                    ></a>
                    <a
                      class="rating-icon rating-goed"
                      :class="'rating-' + question.rating"
                      ><v-radio label="goed" value="4"></v-radio
                    ></a>
                    <a
                      class="rating-icon rating-super"
                      :class="'rating-' + question.rating"
                      ><v-radio label="super" value="5"></v-radio
                    ></a>
                  </v-radio-group>
                </div>

                <div
                  class="feedback-option"
                  v-if="question.rating <= compData.surveyFeedbackAsk"
                >
                  <div class="feedback-option-label">
                    <span
                      v-if="
                        question.rating < 4 &&
                          question.rating <= compData.surveyFeedbackAsk
                      "
                    >
                      <span v-if="survey.clientLanguage == 'nl'"
                        >Wat hadden wij beter kunnen doen?</span
                      >
                      <span v-else>What could we have done better?</span>
                    </span>
                    <span
                      v-if="
                        question.rating == 4 &&
                          question.rating <= compData.surveyFeedbackAsk
                      "
                    >
                      <span v-if="survey.clientLanguage == 'nl'"
                        >Wat kunnen we nog verbeteren?</span
                      >
                      <span v-else>What can we improve?</span>
                    </span>
                    <span
                      v-if="
                        question.rating == 5 &&
                          question.rating <= compData.surveyFeedbackAsk
                      "
                    >
                      <span v-if="survey.clientLanguage == 'nl'"
                        >Wat vond je zo geweldig?</span
                      >
                      <span v-else>What did you love so much?</span>
                    </span>
                  </div>

                  <textarea
                    placeholder="Schrijf hier je feedback..."
                    v-model="question.feedback"
                  ></textarea>
                </div>
              </div>

              <div
                class="survey-item feedback"
                v-if="
                  question.dateUpdated == null && question.type == 'feedback'
                "
              >
                <h2>{{ question.question[survey.clientLanguage] }}</h2>
                <textarea
                  placeholder="Reageer hier..."
                  v-model="question.feedback"
                ></textarea>
              </div>
            </div>
          </div>

          <div v-if="noSurveyFound == false" class="survey-footer text-center">
            <p class="ma-0">{{ compData.name }} &#9400;</p>
          </div>
        </v-card-text>
      </v-card>

      <v-btn
        fixed
        right
        bottom
        rounded
        dark
        :color="compData.colors.primary.hex"
        v-if="changed == true"
        @click="updateQuestions()"
        >Feedback versturen
        <span v-if="averageScore > 0" class="average-score-button"
          >({{ averageScore }})</span
        >
        <v-icon right dark>arrow_forward_ios</v-icon></v-btn
      >
    </div>

    <div v-else class="response-loading">
      <div class="response-loading-icon">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import _ from "lodash";
import { log } from "util";

export default {
  name: "Response",
  props: ["id", "answerdQuestionId", "answerdQuestionRating"],
  data() {
    return {
      survey: {},
      surveyData: [],
      surveyDataOriginal: [],
      compData: {},
      ratingSumData: [],
      dataChanged: false,
      dataLeft: null,
      loading: true,
      noSurveyFound: true,
      surveyValid: true,
      questionsLeft: [],
    };
  },

  mounted() {
    this.responseCheck();
  },

  updated() {
    this.checkForUpdates();
  },

  methods: {
    calcUltimateResponseDate() {
      let todayUnix = moment().format("X");
      let dateSendUnix = this.survey.dateSend.seconds;
      let maxDays = 30;
      let maxDaysUnix = maxDays * 24 * 60 * 60;
      let maxDateUnix = dateSendUnix + maxDaysUnix;
      let maxDateMoment = moment.unix(maxDateUnix).format("D MMM YYYY");
      let dateSendMoment = moment.unix(dateSendUnix).format("D MMM YYYY");
      if (maxDateUnix < todayUnix) {
        this.surveyValid = false;
      }
    },

    ratingSum() {
      this.ratingSumData = [];
      this.surveyData.forEach((element) => {
        if (element.rating) {
          this.ratingSumData.push(Number(element.rating));
        }
      });
    },

    checkForUpdates() {
      let dataChanged = false;
      let questionsLeft = [];
      this.surveyData.forEach((question) => {
        if (
          (!question.answered && question.rating) ||
          (!question.answered && question.feedback)
        ) {
          // console.log("Vraag " + question.order + " is gewijzigd");
          dataChanged = true;
          questionsLeft.push(question.id);
        } else if (!question.answered) {
          // console.log("Vraag " + question.order + " is nog niet beantwoord");
          questionsLeft.push(question.id);
        } else if (question.answered) {
          // console.log("Vraag " + question.order + " is beantwoord");
        }
      });
      this.dataChanged = dataChanged;
      this.dataLeft = questionsLeft.length;
      this.questionsLeft = questionsLeft;
    },

    responseCheck() {
      this.loading = true;
      db.collection("surveys")
        .doc(this.id)
        .get()
        .then((doc) => {
          this.survey = doc.data();
          this.survey.id = doc.id;
          this.surveyData = _.orderBy(
            this.survey.surveyQuestions,
            "order",
            "asc",
          );
          this.surveyDataOriginal = _.cloneDeep(this.surveyData);
        })
        .then(() => {
          // Check if url params are available
          if (this.answerdQuestionRating && this.answerdQuestionId) {
            console.log("Url params found");

            // Check if first answere is already placed
            if (this.survey.answered == false) {
              console.log("No answered questions in survey");

              let today = new Date();
              let firstResponseData = [];

              // Find question answered in params
              new Promise((resolve, reject) => {
                let counter = 0;
                this.surveyData.forEach((question) => {
                  if (question.id == this.answerdQuestionId) {
                    question.dateUpdated = today;
                    question.rating = Number(this.answerdQuestionRating);
                    firstResponseData.push(question);
                    counter++;
                    if (counter === this.surveyData.length) {
                      resolve();
                    }
                  } else {
                    firstResponseData.push(question);
                    counter++;
                    if (counter === this.surveyData.length) {
                      resolve();
                    }
                  }
                });
              })
                .then(() => {
                  this.ratingSum();
                })
                .then(() => {
                  db.collection("surveys")
                    .doc(this.id)
                    .update({
                      surveyQuestions: firstResponseData,
                      ratingSummary: this.ratingSumData,
                      answered: true,
                    })
                    .then(() => {
                      // Update surveyData
                      this.surveyData = firstResponseData;
                      this.surveyDataOriginal = _.cloneDeep(this.surveyData);
                    });
                });
            } else {
              console.log("Already answered questions in survey");
            }
          } else {
            console.log("No url params found");
          }
        })
        .then(() => {
          db.collection("companies")
            .doc(this.survey.compId)
            .get()
            .then((doc) => {
              this.compData = {};
              let companyData = doc.data();
              companyData.id = doc.id;
              this.compData = companyData;
            })
            .then(() => {
              this.ratingSum();
            })
            .then(() => {
              this.noSurveyFound = false;
              this.loading = false;
            })
            .catch((error) => {
              console.error("Error getting company document: ", error);
            });
        })
        .catch((error) => {
          console.error("Error getting survey document: ", error);
          this.loading = false;
        });
    },

    updateQuestions() {
      let today = new Date();
      let responseData = [];
      new Promise((resolve, reject) => {
        let counter = 0;
        this.surveyData.forEach((question) => {
          if (
            (question.rating && !question.answered) ||
            (question.feedback && !question.answered)
          ) {
            let newQuestion = {};
            newQuestion.compId = question.compId;
            newQuestion.id = question.id;
            newQuestion.journeyId = question.journeyId;
            newQuestion.order = question.order;
            newQuestion.stageId = question.stageId;
            newQuestion.question = question.question;
            newQuestion.type = question.type;
            newQuestion.answered = true;
            newQuestion.dateUpdated = today;
            newQuestion.rating = Number(question.rating);

            if (question.feedback) {
              newQuestion.feedback = question.feedback;
            }
            responseData.push(newQuestion);
            counter++;
            if (counter === this.surveyData.length) {
              resolve();
            }
          } else {
            responseData.push(question);
            counter++;
            if (counter === this.surveyData.length) {
              resolve();
            }
          }
        });
      }).then(() => {
        db.collection("surveys")
          .doc(this.id)
          .update({
            surveyQuestions: responseData,
            ratingSummary: this.ratingSumData,
            answered: true,
          })
          .then(() => {
            this.responseCheck();
          });
      });
    },

    add(a, b) {
      return a + b;
    },
  },
  computed: {
    changed() {
      if (_.isEqual(this.surveyData, this.surveyDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },

    averageScore() {
      if (this.ratingSumData.length > 0) {
        let givenRatings = this.ratingSumData.reduce(this.add, 0);
        let avarageScore;
        avarageScore = ((givenRatings * 2) / this.ratingSumData.length).toFixed(
          1,
        );
        return avarageScore;
      } else {
        return 0;
      }
    },
  },
};
</script>
<style>
.extra-survey-intro-header,
.extra-survey-intro-header span {
  font-weight: 600;
}
</style>
